<div class="lnr-sidemenu-container">
  <app-sidemenu-item id="lnr-sidemenuitem-home" (click)="onRoute(RoutesKeys.HOME)"
                     icon="{{ sideMenuItems.home[1] }}">
    {{ sideMenuItems.home[0] }}
  </app-sidemenu-item>
  <app-sidemenu-item id="lnr-sidemenuitem-businessList" (click)="onRoute(RoutesKeys.BUSINESS_LIST)"
                     icon="{{ sideMenuItems.businessList[1] }}">
    {{ sideMenuItems.businessList[0] }}
  </app-sidemenu-item>
  <app-sidemenu-item id="lnr-sidemenuitem-rewards" (click)="onRoute(RoutesKeys.REWARDS)"
                     icon="{{ sideMenuItems.rewards[1] }}">
    {{ sideMenuItems.rewards[0] }}
  </app-sidemenu-item>
</div>
